<template>
  <span v-html="data.html" class="wp-html"> </span>
</template>

<script>
export default {
  name: 'BlockHtml',
  props: ['data'],
}
</script>

<style>
.wp-html.wp-block {
}
.wp-block-core-image figure,
.wp-block-core-gallery figure {
  margin: 0;
}

.wp-block-core-image figure img,
.wp-block-core-gallery figure img {
  max-width: 100%;
}
.wp-element-caption,
.wp-block-image > figcaption {
  text-transform: uppercase;
  font-family: 'din';
}
.wp-block-image > figcaption em {
  font-style: normal !important;
}
.wp-block-separator {
  border: none;
  border-top: 1px solid #d5d5d5;
}
</style>
